// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e786","label":"styles_label__2D540"};